module.exports = __webpack_public_path__ + "static/img/new-5.5c320d40.jpg";